export default __webpack_public_path__ + "static/media/icon-heart.6dccde68.svg";